import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'antd-mobile';
class AutoRefresh extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadData: false
    };
  }
  handleScroll = (e) => {
    const el = e.target;
    const scrollHeight = el.scrollHeight;
    const scrollTop = el.scrollTop;
    const height = el.clientHeight;
    if (scrollHeight - scrollTop <= height) {
      this.props.onRefresh();
    }
  };
  goToTop = () => {
    let ele = document.getElementById('auto-scroll');
    ele.scrollTop = 0;
  };
  renderMsg = () => {
    const { total, size } = this.props;
    let msg = null;
    if (total > 0) {
      if (total > size) {
        msg = '滑动刷新';
      } else if (total === size) {
        msg = '以上是全部数据';
      } else if (total < size) {
        msg = <Icon type={'loading'} />;
      }
    } else {
      msg = '当前条件无数据';
    }
    return msg;
  };
  render() {
    const { top } = this.props;
    // console.log(this.props.children.clientHeight);
    return (
      <div
        onScroll={this.handleScroll}
        id={'auto-scroll'}
        style={{
          height: window.HEIGHT - (top || 0),
          overflowY: 'scroll',
          overflowX: 'hidden'
          // border: '1px solid red'
        }}
      >
        {this.props.children || null}
        <div
          style={{
            textAlign: 'center',
            color: '#666'
          }}
        >
          {this.renderMsg()}
        </div>
      </div>
    );
  }
}
AutoRefresh.propTypes = {
  onRefresh: PropTypes.func.isRequired, //必须有，且必须是个方法。
  top: PropTypes.number, // 距离顶部的距离
  total: PropTypes.number, // 总共的条数
  size: PropTypes.number // 现在有几条。
};
AutoRefresh.defaultProps = {
  top: 0, // 距离顶部的距离
  total: 0, // 总共的条数
  size: 0 // 现在有几条。
};
export default AutoRefresh;
